<template>
    <Head title="تیکت‌ها"/>
    <dashboard>
        <template v-slot:breadcrumb>
            <breadcrumb :links="[{title: 'تیکت‌ها', url: '/dashboard/tickets'}]"/>
        </template>

        <div class="shadow p-4 rounded">
            <h1 class="h2 fw-bold mb-4">{{ ticket.title }}</h1>
            <div class="mb-4 row g-3 justify-content-between align-items-center">
                <div class="col-12 col-lg">
                    <small class="fw-bold">
                        تیکت در
                        {{ moment(ticket.created_at) }}
                        ایجاد شده
                    </small><br/>
                    <span v-if="ticket.latestMessage.is_admin"
                          class="badge bg-warning text-black me-2">پاسخ داده شده</span>
                    <span v-else class="badge bg-secondary text-white me-2">در انتظار پاسخ</span>
                    <span class="badge bg-primary text-white me-2">دپارتمان {{ ticket.department.title }}</span>
                    <span v-if="ticket.closed_at" class="badge bg-danger text-white">تیکت در
                    {{ moment(ticket.closed_at) }}
                        بسته شده</span>
                    <span v-else class="badge bg-info text-white">تیکت باز</span>
                </div>
                <div class="col-12 col-lg-auto">
                    <Link v-if="ticket.closed_at" :href="`/dashboard/tickets/${ticket.uuid}`" method="put"
                          :data="{closed: false}" as="button" class="btn btn-lg btn-secondary fw-bold">باز کردن تیکت
                    </Link>
                    <Link v-else :href="`/dashboard/tickets/${ticket.uuid}`" method="put" :data="{closed: true}"
                          as="button" class="btn btn-lg btn-secondary fw-bold">بستن تیکت
                    </Link>
                </div>
            </div>
            <div v-if="ticket.billItem" class="mb-4 p-3 border rounded">
                <h6 class="fw-semibold">
                    سفارش {{ ticket.billItem.bill.tracking_code }}
                </h6>
                <h6 class="fw-semibold">
                    {{ ticket.billItem.description.product_title }}
                </h6>
                <div>
                    {{ ticket.billItem.description.state_title }}
                    <span class="badge bg-white text-dark">X {{ toFaNum(ticket.billItem.count) }} عدد</span>
                    <span v-if="ticket.billItem.status === 'complete'"
                          class="badge bg-info ms-2">تکمیل شده</span>
                    <span v-else class="badge bg-danger ms-2">در صف</span>
                </div>
            </div>
            <form ref="messageFormRef" @submit.prevent="submitForm" v-if="!ticket.closed_at" class="">
                <div class="mb-3">
                    <textarea v-model="form.message" class="form-control form-control-lg" rows="10" placeholder="متن تیکت"></textarea>
                    <div v-if="form.errors.message" class="invalid-feedback d-block fw-bold mt-2">
                        {{ form.errors.message }}
                    </div>
                </div>
                <div class="mb-3">
                    <input @change="form.attachments = $event.target.files" class="form-control form-control-lg" type="file" multiple placeholder="فایل‌های ضمیمه">
                    <div class="d-block fw-bold mt-2 text-dark">
                        در این قسمت حداکثر ۳ عکس با حداکثر حجم ۱ مگابایت می‌توانید آپلود کنید.
                    </div>
                    <div v-if="form.errors.attachments" class="invalid-feedback d-block fw-bold mt-2">
                        {{ form.errors.attachments }}
                    </div>
                    <div v-for="errorKey in Object.keys(form.errors).filter(i => i.startsWith('attachments.'))" class="invalid-feedback d-block fw-bold mt-2">
                        {{ form.errors[errorKey] }}
                    </div>
                </div>
                <div class="mb-4 text-end">
                    <button type="submit" :disabled="form.processing"
                            class="btn btn-primary bg-gradient-primary border-0 text-white btn-lg fw-bold fs-6 py-3 px-5">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M3.35288 8.95043C4.00437 6.17301 6.17301 4.00437 8.95043 3.35288C10.9563 2.88237 13.0437 2.88237 15.0496 3.35288C17.827 4.00437 19.9956 6.17301 20.6471 8.95044C21.1176 10.9563 21.1176 13.0437 20.6471 15.0496C19.9956 17.827 17.827 19.9956 15.0496 20.6471C13.0437 21.1176 10.9563 21.1176 8.95044 20.6471C6.17301 19.9956 4.00437 17.827 3.35288 15.0496C2.88237 13.0437 2.88237 10.9563 3.35288 8.95043Z"
                                stroke="currentColor" stroke-width="1.5"/>
                            <path d="M14.5 12H9.5M12 14.5L12 9.5" stroke="currentColor" stroke-width="1.5"
                                  stroke-linecap="round"/>
                        </svg>
                        ارسال
                    </button>
                </div>
            </form>
            <div v-for="message in messages.data" class="card mb-3"
                 :class="message.is_admin ? 'ms-4' : 'me-4 bg-light'">
                <div class="card-body">
                    <div class="hstack gap-3 justify-content-between mb-2">
                        <div class="fw-bold">{{ message.is_admin ? 'پاسخ پشتیبان' : 'من' }}</div>
                        <div>
                                <span class="badge text-dark"
                                      :class="message.is_admin ? 'bg-white' : 'bg-light'">{{
                                        moment(message.created_at)
                                    }}</span>
                        </div>
                    </div>
                    <div v-if="message.is_admin" v-html="message.message">
                    </div>
                    <div v-else class="ws-pre">
                        {{ message.message }}
                    </div>
                    <div v-if="message.attachments.length" class="mt-2">
                        <a v-for="attachment in message.attachments" :href="`/dashboard/ticket-attachments/${attachment.uuid}`" target="_blank" class="me-1">
                            <img width="100" height="100" :src="`/dashboard/ticket-attachments/${attachment.uuid}?size=thumb`">
                        </a>
                    </div>
                </div>
            </div>

            <nav v-if="messages.meta.last_page > 1">
                <ul class="pagination mb-0">
                    <li v-for="link in messages.meta.links" class="page-item" :class="{disabled: !link.url, active:link.active}">
                        <Link class="page-link" :href="link.url">
                            <span aria-hidden="true" v-html="link.label"></span>
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    </dashboard>
</template>

<script>
import Dashboard from "../../Layouts/Dashboard";
import Breadcrumb from "../../Components/Breadcrumb";
import {moment} from "../../helpers";

import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import {ref} from "vue";

export default {
    components: {
        Dashboard,
        Breadcrumb,
        Head,
        Link,
    },
    props: {
        ticket: Object,
        messages: Object,
    },
    setup(props) {
        const messageFormRef = ref()

        const form = useForm({
            message: null,
            attachments: [],
        })

        const submitForm = () => {
            form.post('/dashboard/tickets/' + props.ticket.uuid, {
                onSuccess: () => {
                    form.reset()
                    messageFormRef.value.reset()
                },
                preserveScroll: true,
            })
        }

        return {moment, form, submitForm, messageFormRef}
    }
}
</script>

<style scoped>
.ws-pre {
    white-space: pre-line !important;
}
</style>
